import React from "react";
import { Form } from "react-bootstrap";

function NomineeDetail({
  continueStepEvent,
  backStepEvent,
  handleChange,
  formObj,
  isPreview,
  comboResponse,
}) {
  const detailObject = formObj.nomineeDetail;
  const continueFormEvent = (e) => {
    e.preventDefault();
    continueStepEvent("nomineeDetail");
  };
  return (
    <div className="tab-pane" role="tabpanel" id="step5">
      <Form onSubmit={(e) => continueFormEvent(e)}>
        <div className="row">
          <h4 className="my-3">Nominee Details</h4>

          <div className="col-md-4">
            <div className="form-group">
              <label>Enter Name (Mr./Ms./Mrs.) *</label>
              <input
                value={detailObject.nominee_name.value}
                className="form-control"
                onChange={(e) => handleChange(e, "nomineeDetail", "nominee_name")}
                type="text"
                placeholder="Enter Name (Mr./Ms./Mrs.)"
                disabled={isPreview ? true : false}
              />
            </div>
          </div>

          <div className="col-md-4">
            <div className="form-group">
              <label>CNIC/NICOP No. *</label>
              <input
                value={detailObject.nominee_cnic.value}
                onChange={(e) =>
                  handleChange(e, "nomineeDetail", "nominee_cnic")
                }
                className="form-control"
                type="tel"
                // pattern="[0-9]{5}[0-9]{7}[0-9]{1}"
                required
                name="CNIC/NICOP NO."
                placeholder="Enter CNIC/NICOP No."
                disabled={isPreview ? true : false}
              />
            </div>
          </div>

          <div className="col-md-4">
            <div className="form-group">
              <label>CNIC Issuance Date *</label>
              <input
                value={detailObject.nominee_cnic_issuance_date.value}
                onChange={(e) =>
                  handleChange(e, "nomineeDetail", "nominee_cnic_issuance_date")
                }
                className="form-control"
                type="date"
                required
                placeholder="Enter CNIC Issuance Date"
                disabled={isPreview ? true : false}
              />
            </div>
          </div>

          <div className="col-md-4">
            <div className="form-group">
              <label>Address *</label>
              <input
                required
                value={detailObject.current_residential_address.value}
                onChange={(e) =>
                  handleChange(
                    e,
                    "nomineeDetail",
                    "current_residential_address"
                  )
                }
                className="form-control"
                type="text"
                name="Father Name"
                placeholder="Enter Address"
                disabled={isPreview ? true : false}
              />
            </div>
          </div>

          <div className="col-md-4">
            <div className="form-group">
              <label>City *</label>
              <Form.Select
                value={detailObject.nominee_city.value}
                className="form-control"
                required
                disabled={isPreview ? true : false}
                placeholder="Select Financing Option"
                onChange={(e) =>
                  handleChange(e, "nomineeDetail", "nominee_city")
                }
              >
                <option value="">Select City</option>
                {comboResponse?.City.map((item, index) => {
                  return (
                    <option key={index} value={item.key}>
                      {item.value}
                    </option>
                  );
                })}
              </Form.Select>
            </div>
          </div>

          <div className="col-md-4">
            <div className="form-group">
              <label>Relationship *</label>
              <Form.Select
                value={detailObject.relationship.value}
                className="form-control"
                required
                disabled={isPreview ? true : false}
                placeholder="Nominee Relation"
                onChange={(e) => handleChange(e, "nomineeDetail", "relationship")}
              >
                <option value="">Select Relation</option>
                {comboResponse?.Relationship.map((item, index) => {
                  return (
                    <option key={index} value={item.key}>
                      {item.value}
                    </option>
                  );
                })}
              </Form.Select>
            </div>
          </div>

          {/* <div className="col-md-4">
            <div className="form-group">
              <label>Email Address *</label>
              <input
                required
                value={detailObject.email.value}
                onChange={(e) => handleChange(e, "nomineeDetail", "email")}
                className="form-control"
                type="text"
                name="Email"
                placeholder="Enter Address"
                disabled={isPreview ? true : false}
              />
            </div>
          </div> */}

          <div className="col-md-4">
            <div className="form-group">
              <label>Mobile Phone Number *</label>
              <input
                required
                value={detailObject.nominee_mobile_no.value}
                onChange={(e) =>
                  handleChange(e, "nomineeDetail", "nominee_mobile_no")
                }
                className="form-control"
                type="tel"
                name="PHONE NUMBER"
                placeholder="eg. +92xxxxxxxxxx"
                disabled={isPreview ? true : false}
              />
            </div>
          </div>

          <div className="col-md-4">
            <div className="form-group">
              <label>Landline Number *</label>
              <input
                required
                value={detailObject.landline_number.value}
                onChange={(e) =>
                  handleChange(e, "nomineeDetail", "landline_number")
                }
                className="form-control"
                type="tel"
                name="Landline Number"
                placeholder="eg. +92213xxxxxxx"
                disabled={isPreview ? true : false}
              />
            </div>
          </div>
        </div>

        {/* To View Final Page Details */}
        {!isPreview ? (
          <ul className="list-inline pull-right">
            <li>
              <button
                type="button"
                className="default-btn prev-step"
                onClick={backStepEvent}
              >
                Back
              </button>
            </li>
            <li></li>
            <li>
              <button type="submit" className="default-btn next-step">
                Continue
              </button>
            </li>
          </ul>
        ) : (
          ""
        )}
      </Form>
    </div>
  );
}

export default NomineeDetail;
